import React from 'react';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import Container from './components/container';
import PasswordChange from './pages/passwordChange';
import NotFound from './pages/notFound';
import Login from './pages/login';
import { Panel } from './pages/panel';

import 'antd/dist/antd.css';
import './styles/app.scss';

const App = () => {
	return (
		<Container className="container flex flex-jc flex-ac">
			<React.Suspense fallback={<h1>Ładowanie...</h1>}>
				<BrowserRouter>
					<Routes>
						<Route path="/" element={<Login />} />
						<Route path="/passchange" element={<PasswordChange />} />
						<Route path="/logout" element={<Login />} />
						{/* <Route path="/panel" element={<React.lazy(() => import('./pages/panel'))} /> */}
						<Route path="/panel/*" element={<Panel />} />
						<Route path="*" element={<NotFound />} />
					</Routes>
				</BrowserRouter>
			</React.Suspense>
		</Container>
	);
};

export default App;
